"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import styled from "styled-components";
import { space, typography } from "styled-system";
import { getThemeValue } from "../../utils";
import { textSize, textVariant, textWeight } from "./types";
const getColor = ({
  color,
  theme
}) => {
  return getThemeValue(`colors.${color}`, color)(theme);
};
const getFontWeight = ({
  weight,
  theme
}) => {
  return getThemeValue(`fontWeights[${weight}]`, weight)(theme);
};
const getFontSize = ({
  fontSize,
  theme
}) => {
  return getThemeValue(`fontSizes.${fontSize}`, fontSize)(theme);
};
const returnType = (variant, text, textHtml, fontClassName) => {
  switch (variant) {
    case textVariant.H1:
      return <h1>
          <>{text}</>
        </h1>;
    case textVariant.H2:
      return <h2>
          <>{text}</>
        </h2>;
    case textVariant.H3:
      return <h3>
          <>{text}</>
        </h3>;
    case textVariant.H4:
      return <h4>
          <>{text}</>
        </h4>;
    case textVariant.H5:
      return <h5>
          <>{text}</>
        </h5>;
    case textVariant.H6:
      return <h6>
          <>{text}</>
        </h6>;
    default:
      if (textHtml?.length && textHtml.length > 0) {
        return <div dangerouslySetInnerHTML={{
          __html: textHtml
        }} />;
      }
      return <p className={fontClassName}>
          <>{text}</>
        </p>;
  }
};
const Text = t0 => {
  const $ = _c(16);
  const {
    text,
    color,
    textTransform,
    variant: t1,
    fontSize: t2,
    weight: t3,
    className,
    onClick,
    textDecoration,
    textHtml,
    fontClassName
  } = t0;
  const variant = t1 === undefined ? textVariant.P : t1;
  const fontSize = t2 === undefined ? textSize.M : t2;
  const weight = t3 === undefined ? textWeight.NORMAL : t3;
  const t4 = text ?? "";
  let t5;
  if ($[0] !== fontClassName || $[1] !== t4 || $[2] !== textHtml || $[3] !== variant) {
    t5 = returnType(variant, t4, textHtml, fontClassName);
    $[0] = fontClassName;
    $[1] = t4;
    $[2] = textHtml;
    $[3] = variant;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== className || $[6] !== color || $[7] !== fontSize || $[8] !== onClick || $[9] !== t5 || $[10] !== text || $[11] !== textDecoration || $[12] !== textTransform || $[13] !== variant || $[14] !== weight) {
    t6 = <TextWrapper text={text} variant={variant} color={color} weight={weight} textTransform={textTransform} fontSize={fontSize} className={className} onClick={onClick} textDecoration={textDecoration}>{t5}</TextWrapper>;
    $[5] = className;
    $[6] = color;
    $[7] = fontSize;
    $[8] = onClick;
    $[9] = t5;
    $[10] = text;
    $[11] = textDecoration;
    $[12] = textTransform;
    $[13] = variant;
    $[14] = weight;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
const TextWrapper = styled.div`
  color: ${({
  color,
  theme
}) => getColor({
  color,
  theme
})} !important;
  font-stretch: normal;
  font-style: normal;
  font-weight: ${({
  weight,
  theme
}) => getFontWeight({
  weight,
  theme
})} !important;

  h1 {
    font-size: ${({
  fontSize,
  theme
}) => fontSize ? getFontSize({
  fontSize,
  theme
}) : "3.5rem"} !important;
    line-height: 120%;
    letter-spacing: -0.01em;
  }

  h2 {
    font-size: 3rem;
    line-height: 130%;
  }

  h3 {
    font-size: 2.5rem;
    line-height: 130%;
  }

  h4 {
    font-size: 2rem;
    line-height: 130%;
  }

  h5 {
    font-size: 1.5rem;
    line-height: 140%;
  }

  h6 {
    font-size: 1.25rem;
    line-height: 140%;
  }

  p {
    font-size: ${theme => getFontSize(theme)} !important;
    line-height: 150%;
  }

  a {
    color: ${({
  theme
}) => theme.colors.BLUE} !important;
  }

  ${({
  textTransform
}) => textTransform && `text-transform: ${textTransform};`}
  ${({
  textDecoration
}) => textDecoration && `text-decoration: ${textDecoration};`}
  ${space}
  ${typography}
`;
export default Text;